var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 0.875C7.38825 0.875 7.74645 1.08008 7.94333 1.41641L13.8496 11.4789C14.0492 11.818 14.0492 12.2363 13.855 12.5754C13.6609 12.9145 13.2972 13.125 12.9062 13.125H1.09372C0.702702 13.125 0.33903 12.9145 0.144889 12.5754C-0.0492514 12.2363 -0.0465171 11.8152 0.150358 11.4789L6.05661 1.41641C6.25348 1.08008 6.61169 0.875 6.99997 0.875ZM6.99997 4.375C6.6363 4.375 6.34372 4.66758 6.34372 5.03125V8.09375C6.34372 8.45742 6.6363 8.75 6.99997 8.75C7.36364 8.75 7.65622 8.45742 7.65622 8.09375V5.03125C7.65622 4.66758 7.36364 4.375 6.99997 4.375ZM7.87497 10.5C7.87497 10.2679 7.78278 10.0454 7.61869 9.88128C7.45459 9.71719 7.23203 9.625 6.99997 9.625C6.7679 9.625 6.54534 9.71719 6.38125 9.88128C6.21715 10.0454 6.12497 10.2679 6.12497 10.5C6.12497 10.7321 6.21715 10.9546 6.38125 11.1187C6.54534 11.2828 6.7679 11.375 6.99997 11.375C7.23203 11.375 7.45459 11.2828 7.61869 11.1187C7.78278 10.9546 7.87497 10.7321 7.87497 10.5Z",
    fill: "#565D6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b3e602a90c9b2daaceeb8afdea32cb6f.svg";
export { ForwardRef as ReactComponent };